export class Uro {

userId!: string;  
roleId!: string;
officeId!: string;

}
